import React, {useState, useEffect, useCallback} from 'react'
import moment from 'moment'
import _ from 'lodash'
import ApartmentsOwnersPortalMenu from './menu'
import ApartmentOwnersPortalCalendar from './calendar'
import {  GetUserParams } from '../../api/services/organization';
import { GetReservations, GetReservationTotals } from '../../api/services/pms'
import { RoomPlannedMaintenance } from '../../api/services/next';
import { getContrastYIQ } from '../../components/shared/utils'
import { GetHotels } from '../../api/services/organization';
import { MaintenanceStatusTypes } from '../../components/shared/statustypes';
import { useLoader } from '../../hooks/useLoader'

const ApartmentOwnersPortal = () => {  
    const loader = useLoader()
    const [currentApartmentId, setCurrentApartmentId] = useState(0);
    const [user, setUser] = useState({});
    const [hotelsList, setHotelsList] = useState([]);
    const [hotel, setHotel] = useState({});
    const [apartmentOwner, setApartmentOwner] = useState({});
    const [reservations, setReservations] = useState([]);
    const [userLanguage, setUserLanguage] = useState(document.documentElement.lang)
    const [displayPrice, setDisplayPrice] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                let userparams = await GetUserParams(); 
                const hotels = await GetHotels({ HotelChainID: userparams.Hotel.HotelChainId, IsActive: true, IncludeParameters: true, IncludeOnlyHotelsWithUserPermissions: true })
                setHotelsList(hotels);
                const currentHotel = hotels.find(hotel => hotel.Id == userparams.Hotel.Id);
                setHotel(currentHotel);
                setUser(userparams.User);
                setUserLanguage(userparams.User.UserSettings[0]?.Language?.LocaleID || document.documentElement.lang)
            } catch (error) {
                console.error(error)
            }
        })()
    }, [])

/* #region  Loading reservations */
const eventsFunction = useCallback(async (fetchInfo, successCallback, failureCallback) => {
    if (hotel.Id && currentApartmentId > 0) {
        try {
            loader(true);
            let reservations = await GetReservations(
                {
                    IncludeGuest: true,
                    IncludeGuestImages: true,
                    IncludeReservationCompanyAgent: true,
                    IncludeReservationDailyAccommodations: true,
                    IncludeAddons: true,
                    IncludeAddonsWithChain: true,
                    IncludeRoomType: true,
                    IncludePartyColor: true,
                    HotelID: hotel.Id,
                    RoomID: currentApartmentId,
                    IsReservationsAssignedToRoomsOnly: true,
                    CheckInDate: fetchInfo.startStr,
                    CheckOutDate: fetchInfo.endStr
                })
            setReservations(reservations);
            let maintenance = await RoomPlannedMaintenance.GetRoomPlannedMaintenances({
                    IsActive: true,
                    StartDate: fetchInfo.startStr,
                    EndDate: fetchInfo.endStr,
                    GetPlannedMaintenanceStatusesContainedInRange: false,
                    HotelID: hotel.Id,
                    RoomIDs: [currentApartmentId]
                })
            const values = await Promise.all(_.concat(reservations, maintenance))
            const data = _.flatMap(values)

            const totals = _.flatMap(await Promise.all(_.map(_.groupBy(_.filter(data, x => !x.MaintenanceStatusTypeId), "HotelId"), (reservations) => {
                return GetReservationTotals({
                    ReservationIDs: _.map(reservations, "Id"),
                    HotelId: hotel.Id,
                    TargetCurrencyID: hotel.MainCurrencyId
                })
            })))

            let events = _.reduce(data, (result, reservation) => {

                if (reservation.MaintenanceStatusTypeId) { // Handle maintenance event
                    result.push({
                        id: reservation.Id,
                        title: MaintenanceStatusTypes[reservation.MaintenanceStatusTypeId],
                        start: moment.utc(reservation.StartDate).hour(12).toISOString(),
                        end: moment.utc(reservation.EndDate).hour(12).toISOString(),
                        extendedProps: { maintenance: reservation, hotel: hotel },
                        classNames: "maintenance"
                    })
                } else { // Handle reservation event
                    const IsHomogeneous = _.every(reservation.ReservationDailyAccommodations, ["RoomId", reservation.RoomId])
                    //const title = GetFullName(reservation.Guest) + " #" + reservation.Number
                    let classes = ""

                    // if (selected && selected.event.id === reservation.Id) {
                    //     classes += "selected "
                    // }
                    if (IsHomogeneous) {
                        result.push({
                            id: reservation.Id,
                            //title: title,
                            start: moment.utc(reservation.CheckInDate).hour(12).toISOString(),
                            end: moment.utc(reservation.CheckOutDate).hour(12).toISOString(),
                            extendedProps: { reservation: reservation, hotel: hotel, totals: totals.find(x=>x.ReservationID == reservation.Id) },
                            color: reservation.Color,
                            textColor: getContrastYIQ(reservation.Color || "3788d8"),
                            classNames: classes
                        })
                    } else {
                        const groupped = _.reduce(reservation.ReservationDailyAccommodations, (result, value, index, collection) => {
                            if (!index || value.RoomId != collection[index - 1].RoomId) {
                                result.push([])
                            }
                            result[result.length - 1].push(value);
                            return result;
                        }, [])

                        _.forEach(groupped, group => {
                            const mindate = _.minBy(group, "Date")
                            const maxdate = _.maxBy(group, "Date")
                            result.push({
                                id: reservation.Id,
                                resourceId: group[0].RoomId,
                                //title: title,
                                start: mindate.Date.hour(12),
                                end: moment.utc(maxdate.Date).add(1, "d").hour(12).toISOString(),
                                extendedProps: { reservation: reservation, hotel: hotel, totals: totals.find(x=>x.ReservationID == reservation.Id) },
                                color: reservation.Color,
                                textColor: getContrastYIQ(reservation.Color || "39c2e1"),
                                classNames: classes + "hetero "
                            })
                        })
                    }
                }
                return result
            }, [])
            successCallback(events)
        } catch (err) {
            console.error(err)
            failureCallback(err)
        } finally {
            loader(false)
        }
    }
    else{
        successCallback([])
    }
}, [hotel, currentApartmentId])
/* #endregion */

    useEffect(() => {
        if(apartmentOwner && apartmentOwner.ApartmentOwnerSettings){
            const displayPriceSettings = apartmentOwner.ApartmentOwnerSettings.find(item => item.Name === "DisplayPriceInPortal")
            setDisplayPrice(displayPriceSettings?.Value === "1")
        }
    },[apartmentOwner])


    const updateHotelAndApartment = useCallback((item) => {
        const currentHotel = hotelsList.find(hotel => hotel.Id == item.HotelId);
        setHotel(currentHotel);
        setCurrentApartmentId(item.Id)
        setTimeout(()=>{
            document.querySelector("input.search").blur()
        }, 100) 
        
    },[hotelsList]);

    return (
        <React.Fragment>
            <ApartmentsOwnersPortalMenu 
                user={user} 
                setApartmentOwner={setApartmentOwner}
                apartmentOwner={apartmentOwner}
                updateHotelAndApartment={updateHotelAndApartment}
            />
            <ApartmentOwnersPortalCalendar 
                RoomID={1} 
                ApartmentOwnerID={apartmentOwner && apartmentOwner.Id} 
                eventsFunction={eventsFunction}
                reservations={reservations}
                calendarLanguage={userLanguage}
                displayPrice={displayPrice}
            />
        </React.Fragment>
    )
}

export default ApartmentOwnersPortal
